import { Injectable, NgZone } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private cookieService: CookieService,
    private toaster: ToastrService,
    private ngZone: NgZone,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.isUserLogged()) {
      request = request.clone({
        setHeaders: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.cookieService.get(AuthenticationService.sessionKey),
        },
      });
    }

    return next.handle(request).pipe(
      tap({
        error: (err: unknown) => {
          if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
            return;
          }
          this.ngZone.run(() => {
            this.toaster.error('Session Expired');
            this.cookieService.delete(AuthenticationService.sessionKey);
            this.router.navigate(['/login']).then();
          });
        },
      }),
    );
  }
}
